type ChatBotSettings = {
  appId: string;
};

const setChatbot = ({ appId }: ChatBotSettings) => {
  try {
    window.embeddedservice_bootstrap = window.embeddedservice_bootstrap || {};
    window.embeddedservice_bootstrap.settings.language = "it";
    window.embeddedservice_bootstrap.init(
      appId,
      process.env.GATSBY_SALESFORCE_CHATBOT_ENVIRONMENT,
      process.env.GATSBY_SALESFORCE_CHATBOT_URL,
      {
        scrt2URL: process.env.GATSBY_SALESFORCE_CHATBOT_SCRT2URL,
      },
    );
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error("Error loading Embedded Messaging: ", err);
  }
};

export const loadChatbot = () => {
  if (window.embeddedservice_bootstrap) return;
  const scriptChatBot = document.createElement("script");
  scriptChatBot.type = "text/javascript";
  scriptChatBot.src = process.env.GATSBY_SALESFORCE_CHATBOT_BOOTSTRAP_URL;
  scriptChatBot.onload = () => {
    setChatbot({ appId: process.env.GATSBY_SALESFORCE_CHATBOT_APP_ID });
  };
  const head = document.querySelector("head");
  head?.appendChild(scriptChatBot);
};
